import React, { useCallback, useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { toast } from "react-toastify";
import { useTranslation } from "react-i18next";

import {
  getByNatureActivityTypeKeyWordPage,
  deleteSpecialite,
} from "./ServiceSpecialite";

import ConfirmationModal from "../../components/home/ConfirmationModal";

import "moment/locale/fr";
import moment from "moment";


export default function ListSpecialite() {

  const { t } = useTranslation();


  // ============================================================
  // LABEL TYPE ACTIVITE
  // ============================================================

  const getNatureActivityTypeLabel = (type) => {

    switch (type) {

      case "C":
        return t("monProfile.consultantAgriculture");

      case "L":
        return t("monProfile.livestockAdvisor");

      case "S":
        return t("monProfile.supplier");

      default:
        return type || "";

    }

  };


  // ============================================================
  // PAGINATION
  // ============================================================

  const [totalpage, setTotalPages] = useState(0);

  const [currentPage, setCurrentPage] = useState(0);

  const totalPages = totalpage;


  const range = 1;

  const startRange = Math.max(
    currentPage - range,
    0
  );

  const endRange = Math.min(
    currentPage + range,
    totalPages - 1
  );


  const firstPage = () => {

    setCurrentPage(0);

  };


  const lastPage = () => {

    if (totalPages > 0) {

      setCurrentPage(totalPages - 1);

    }

  };


  const prePage = () => {

    setCurrentPage((page) => {

      if (page <= 0) {

        return 0;

      }

      return page - 1;

    });

  };


  const nextPage = () => {

    setCurrentPage((page) => {

      if (page >= totalPages - 1) {

        return page;

      }

      return page + 1;

    });

  };


  // ============================================================
  // TYPE SPECIALITE
  // ============================================================

  const [val, setVal] = useState("");


  // ============================================================
  // NOMBRE ENREGISTREMENTS
  // ============================================================

  const [nombrEnreg, setNombreEnrg] = useState(5);


  // ============================================================
  // RECHERCHE
  // ============================================================

  const [search, setSearch] = useState("");


  // ============================================================
  // ORDRE
  // ============================================================

  const [order, setOrder] = useState("ASC");


  const SortTableAsc = () => {

    setOrder("ASC");

    setCurrentPage(0);

  };


  const SortTableDesc = () => {

    setOrder("DESC");

    setCurrentPage(0);

  };


  // ============================================================
  // CHAMPS DE TRI
  // ============================================================

  const [
    selectedValues,
    setSelectedValues
  ] = useState([]);


  const handleCheckBoxChange = (e) => {
    const value = e.target.value;
    const checked = e.target.checked;

    setSelectedValues((previous) => {

      if (checked) {

        if (previous.includes(value)) {

          return previous;

        }

        return [
          ...previous,
          value
        ];

      }


      return previous.filter(
        (item) => item !== value
      );

    });


    setCurrentPage(0);

  };


  // ============================================================
  // STRING DES CHAMPS DE TRI
  // ============================================================

  const seletedValuesChaine =
    selectedValues.join(",");


  // ============================================================
  // DONNEES
  // ============================================================

  const [
    specialiteData,
    SetspecialiteData
  ] = useState([]);


  // ============================================================
  // CHARGEMENT
  // ============================================================

  const loadspecialite = useCallback(
    async () => {

      try {

        console.log(
          "=============================================="
        );

        console.log(
          "Chargement des spécialités"
        );

        console.log(
          "val              :",
          val
        );

        console.log(
          "search           :",
          search
        );

        console.log(
          "currentPage      :",
          currentPage
        );

        console.log(
          "nombrEnreg       :",
          nombrEnreg
        );

        console.log(
          "seletedValues    :",
          seletedValuesChaine
        );

        console.log(
          "order            :",
          order
        );

        console.log(
          "=============================================="
        );

        const result =
          await getByNatureActivityTypeKeyWordPage(
            val,
            search,
            currentPage,
            nombrEnreg,
            seletedValuesChaine,
            order
          );


        console.log(
          "RESULT COMPLET :",
          result
        );

        console.log(
          "RESULT.DATA :",
          result?.data
        );

        console.log(
          "RESULT.DATA.CONTENT :",
          result?.data?.content
        );

        console.log(
          "RESULT.DATA.TOTALPAGES :",
          result?.data?.totalPages
        );


        // ======================================================
        // VERIFICATION REPONSE
        // ======================================================

        if (
          result?.data &&
          Array.isArray(result.data.content)
        ) {

          SetspecialiteData(
            result.data.content
          );


          setTotalPages(
            result.data.totalPages || 0
          );

        } else {

          console.error(
            "Structure API inattendue :",
            result
          );


          SetspecialiteData([]);

          setTotalPages(0);

        }


      } catch (error) {

        console.error(
          "Erreur chargement spécialités :",
          error
        );


        SetspecialiteData([]);

        setTotalPages(0);

      }

    },
    [
      val,
      search,
      currentPage,
      nombrEnreg,
      seletedValuesChaine,
      order
    ]
  );


  // ============================================================
  // USE EFFECT
  // ============================================================

  useEffect(() => {

    loadspecialite();

  }, [loadspecialite]);


  // ============================================================
  // CHANGEMENT TYPE
  // ============================================================

  const handleTypeChange = (e) => {

    const value = e.target.value;

    setCurrentPage(0);

    setVal(value);

  };


  // ============================================================
  // CHANGEMENT NOMBRE PAR PAGE
  // ============================================================

  const handleNombreEnregChange = (e) => {

    const value =
      Number(e.target.value);


    console.log(
      "Changement taille page :",
      value
    );


    setCurrentPage(0);

    setNombreEnrg(value);

  };


  // ============================================================
  // RECHERCHE
  // ============================================================

  const handleSearchChange = (e) => {

    const value =
      e.target.value;


    setCurrentPage(0);

    setSearch(value);

  };


  // ============================================================
  // SUPPRESSION
  // ============================================================

  const [
    specialiteId,
    setspecialiteId
  ] = useState(null);


  const [
    showConfirmationModal,
    setShowConfirmationModal
  ] = useState(false);


  const selectId = (id) => {

    setspecialiteId(id);

    setShowConfirmationModal(true);

  };


  const handleCloseModal = () => {

    setShowConfirmationModal(false);

    setspecialiteId(null);

  };


  const deletespecialite = async () => {

    try {

      await deleteSpecialite(
        specialiteId
      );


      setShowConfirmationModal(false);

      setspecialiteId(null);


      toast.success(
        "Enregistrement supprimé !",
        {
          position:
            toast.POSITION.TOP_CENTER,

          autoClose: 2000,

          closeOnClick: true,

          pauseOnHover: true,

          draggable: true,

        }
      );


      await loadspecialite();


    } catch (error) {

      console.error(
        "Erreur suppression spécialité :",
        error
      );


      if (
        error.response &&
        error.response.data &&
        error.response.data.errors
      ) {

        const errorArray =
          error.response.data.errors;


        const formattedErrors =
          errorArray.map(
            (errorMessage, index) => (

              <li
                className="list-group-item"
                key={index}
              >

                {errorMessage}

              </li>

            )
          );


        toast.error(

          <div style={{ width: "15rem" }}>

            <div className="card-header text-danger">

              <h5 className="card-title">

                Erreurs de suppression !

              </h5>

            </div>


            <div className="card-body">

              <ul className="list-group list-group-flush">

                {formattedErrors}

              </ul>

            </div>

          </div>,

          {

            position:
              toast.POSITION.TOP_CENTER,

            autoClose: 4000,

            closeOnClick: true,

            pauseOnHover: true,

            draggable: true,

          }

        );

      }

    }

  };


  // ============================================================
  // RETURN
  // ============================================================

  return (

    <div
      className="container-fluid px-4"
      style={{
        marginTop: "5rem"
      }}
    >

      {/* ======================================================
          BREADCRUMB
          ====================================================== */}

      <nav className="mb-3">

        <ol className="breadcrumb bg-white px-3 py-2 shadow-sm rounded-3">

          <li className="breadcrumb-item">

            <Link
              to="/"
              className="text-decoration-none"
            >

              <i className="fa-solid fa-house me-1"></i>

              {t("menu.home")}

            </Link>

          </li>


          <li className="breadcrumb-item active">

            {t("specialite.titre")}

          </li>

        </ol>

      </nav>


      {/* ======================================================
          HEADER
          ====================================================== */}

      <div className="card shadow-sm border-0 mb-3">

        <div className="card-body d-flex justify-content-between align-items-center">

          <h4 className="mb-0 fw-bold text-primary">

            <i className="fa-solid fa-list me-2"></i>

            {t("specialite.list")}

          </h4>


          <Link
            to="/Addspecialite"
            className="btn btn-primary rounded-circle d-flex align-items-center justify-content-center"
            style={{
              width: "45px",
              height: "45px"
            }}
            title="Ajouter"
          >

            <i className="fa-solid fa-plus"></i>

          </Link>

        </div>

      </div>


      {/* ======================================================
          FILTRES
          ====================================================== */}

      <div className="card shadow-sm border-0 mb-3">

        <div className="card-body">

          <div className="row g-2 align-items-center">


            {/* SEARCH */}

            <div className="col-md-6">

              <div className="input-group">

                <span className="input-group-text bg-white">

                  <i className="fa-solid fa-magnifying-glass"></i>

                </span>


                <input
                  type="search"
                  className="form-control"
                  placeholder={t("button.search")}
                  value={search}
                  onChange={handleSearchChange}
                />

              </div>

            </div>


            {/* PAGE SIZE */}

            <div className="col-md-3">

              <select
                className="form-select"
                value={nombrEnreg}
                onChange={handleNombreEnregChange}
              >

                <option value={5}>
                  5 {t("common.rows")}
                </option>

                <option value={10}>
                  10 {t("common.rows")}
                </option>

                <option value={20}>
                  20 {t("common.rows")}
                </option>

              </select>

            </div>


            {/* TYPE */}

            <div className="col-md-3">

              <select
                className="form-select"
                value={val}
                onChange={handleTypeChange}
              >

                <option value="">
                  {t("consultant.filters.all")}
                </option>

                <option value="C">
                  {t("monProfile.consultantAgriculture")}
                </option>

                <option value="L">
                  {t("monProfile.livestockAdvisor")}
                </option>

              </select>

            </div>


            {/* TRI */}

            <div className="col-md-3 text-end">

              <div className="btn-group">

                <button
                  type="button"
                  className="btn btn-outline-primary"
                  disabled={
                    selectedValues.length === 0
                  }
                  onClick={SortTableAsc}
                >

                  <i className="fa-solid fa-arrow-down"></i>

                </button>


                <button
                  type="button"
                  className="btn btn-outline-primary"
                  disabled={
                    selectedValues.length === 0
                  }
                  onClick={SortTableDesc}
                >

                  <i className="fa-solid fa-arrow-up"></i>

                </button>

              </div>

            </div>

          </div>

        </div>

      </div>


      {/* ======================================================
          TABLE
          ====================================================== */}

      <div className="card shadow-sm border-0">

        <div className="table-responsive">

          <table className="table table-striped table-hover">

            <thead className="table-dark">

              <tr>

                <th>

                  <input
                    type="checkbox"
                    value="natureActivityType"
                    onChange={handleCheckBoxChange}
                  />

                  {" "}
                  {t("monProfile.activityType")}
                </th>


                <th>

                  <input
                    type="checkbox"
                    value="specialite"
                    onChange={handleCheckBoxChange}
                  />

                  {" "}

                  {t("common.french")}

                </th>


                <th>

                  <input
                    type="checkbox"
                    value="specialiteArab"
                    onChange={handleCheckBoxChange}
                  />

                  {" "}

                  {t("common.arabic")}

                </th>


                <th>

                  <input
                    type="checkbox"
                    value="specialiteAng"
                    onChange={handleCheckBoxChange}
                  />

                  {" "}

                  {t("common.english")}

                </th>


                <th className="text-center">

                  {t("common.actions")}

                </th>

              </tr>

            </thead>


            <tbody>

              {specialiteData.length > 0 ? (

                specialiteData.map((item) => (

                  <tr key={item.id}>

                    <td>

                      {getNatureActivityTypeLabel(
                        item.natureActivityType
                      )}

                    </td>


                    <td>
                      {item.specialite}
                    </td>


                    <td>
                      {item.specialiteArab}
                    </td>


                    <td>
                      {item.specialiteAng}
                    </td>


                    <td className="text-center">

                      <Link
                        to={`/Updatespecialite/${item.id}`}
                        className="btn btn-sm btn-outline-success me-2 rounded-circle"
                      >

                        <i className="fa-solid fa-pen"></i>

                      </Link>


                      <button
                        type="button"
                        className="btn btn-sm btn-outline-danger rounded-circle"
                        onClick={() =>
                          selectId(item.id)
                        }
                      >

                        <i className="fa-solid fa-trash"></i>

                      </button>

                    </td>

                  </tr>

                ))

              ) : (

                <tr>

                  <td
                    colSpan="5"
                    className="text-center py-4"
                  >

                    Aucune spécialité trouvée.

                  </td>

                </tr>

              )}

            </tbody>

          </table>

        </div>


        {/* ====================================================
            PAGINATION
            ==================================================== */}

        {totalPages > 0 && (

          <div className="card-footer bg-white border-0">

            <nav>

              <ul className="pagination justify-content-center mb-0">


                {/* FIRST */}

                <li
                  className={`page-item ${
                    currentPage === 0
                      ? "disabled"
                      : ""
                  }`}
                >

                  <button
                    type="button"
                    className="page-link"
                    disabled={currentPage === 0}
                    onClick={firstPage}
                  >

                    «

                  </button>

                </li>


                {/* PREVIOUS */}

                <li
                  className={`page-item ${
                    currentPage === 0
                      ? "disabled"
                      : ""
                  }`}
                >

                  <button
                    type="button"
                    className="page-link"
                    disabled={currentPage === 0}
                    onClick={prePage}
                  >

                    ‹

                  </button>

                </li>


                {/* NUMEROS */}

                {Array.from({
                  length: totalPages
                }).map((_, index) => (

                  <li
                    key={index}
                    className={`page-item ${
                      currentPage === index
                        ? "active"
                        : ""
                    }`}
                  >

                    <button
                      type="button"
                      className="page-link"
                      onClick={() =>
                        setCurrentPage(index)
                      }
                    >

                      {index + 1}

                    </button>

                  </li>

                ))}


                {/* NEXT */}

                <li
                  className={`page-item ${
                    currentPage >= totalPages - 1
                      ? "disabled"
                      : ""
                  }`}
                >

                  <button
                    type="button"
                    className="page-link"
                    disabled={
                      currentPage >=
                      totalPages - 1
                    }
                    onClick={nextPage}
                  >

                    ›

                  </button>

                </li>


                {/* LAST */}

                <li
                  className={`page-item ${
                    currentPage >= totalPages - 1
                      ? "disabled"
                      : ""
                  }`}
                >

                  <button
                    type="button"
                    className="page-link"
                    disabled={
                      currentPage >=
                      totalPages - 1
                    }
                    onClick={lastPage}
                  >

                    »

                  </button>

                </li>

              </ul>

            </nav>

          </div>

        )}

      </div>


      {/* ======================================================
          MODAL
          ====================================================== */}

      <ConfirmationModal
        isOpen={showConfirmationModal}
        onConfirm={deletespecialite}
        onCancel={handleCloseModal}
      />

    </div>

  );

}